import React, { PropsWithChildren } from 'react';
import {
  BackgroundImageContainer,
  SectionLayoutContainer,
  SectionLayoutContent,
  ZIndexType,
} from './SectionLayout.styles';
import { ColorModeBgPropKeys, DataColorMode } from 'src/app/styles/colors';
import { SpacingProps } from '../Spacing.styles';
import { componentPropsToStyledProps } from 'src/app/styles/helper';
import { WidthPropKeys } from 'src/app/styles/spacing';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import AssetWrapper from 'atoms/Asset/AssetWrapper';

interface SectionLayoutProps extends PropsWithChildren, SpacingProps {
  background?: ColorModeBgPropKeys;
  maxWidth?: WidthPropKeys;
  zIndex?: ZIndexType;
  dataColorMode?: DataColorMode;
  backgroundImage?: IGatsbyImageData;
}

const SectionLayout = ({
  background,
  maxWidth,
  zIndex,
  children,
  dataColorMode,
  backgroundImage,
  ...props
}: SectionLayoutProps): JSX.Element => (
  <SectionLayoutContainer
    $background={background}
    data-color-mode={dataColorMode}
  >
    {backgroundImage && (
      <BackgroundImageContainer>
        <AssetWrapper
          imageProps={{
            image: backgroundImage,
            alt: 'Background image',
          }}
          cover
        />
      </BackgroundImageContainer>
    )}
    <SectionLayoutContent
      $maxWidth={maxWidth}
      $zIndex={zIndex}
      {...componentPropsToStyledProps(props)}
    >
      {children}
    </SectionLayoutContent>
  </SectionLayoutContainer>
);

export default SectionLayout;
